const CPF_MASK = "000.000.000-00";

/**
 * Formata uma string como CPF (XXX.XXX.XXX-XX). Aceita apenas dígitos; retorna no máximo 11 dígitos formatados.
 */
export function formatCpf(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  let result = "";
  let i = 0;
  for (const char of CPF_MASK) {
    if (char === "0") {
      if (i >= digits.length) break;
      result += digits[i];
      i += 1;
    } else {
      if (i < digits.length) result += char;
      else break;
    }
  }
  return result;
}

/**
 * Remove formatação do CPF (retorna apenas dígitos).
 */
export function stripCpf(value: string): string {
  return value.replace(/\D/g, "");
}

/**
 * Retorna true se a string tem exatamente 11 dígitos (possível CPF).
 */
export function isCpfLength(value: string): boolean {
  return stripCpf(value).length === 11;
}
